import React, { useState } from "react";

import { useLocation, useNavigate, useTranslation } from "utils";

import { Form, Modal, OptGroup, Option, Select } from "components";

import { FieldWithEnrollmentData } from "pages/app/all-field-view/components/AllFieldsTimeline";

export const SimulationFieldSelectionModal = ({
  fields,
  showModal,
  setSimulationFieldId,
  setShowSimulations,
}: {
  fields: FieldWithEnrollmentData[];
  showModal: boolean;
  setSimulationFieldId: (id: string) => void;
  setShowSimulations: (value: boolean) => void;
}) => {
  const { t } = useTranslation("allFieldView");
  const navigate = useNavigate();
  const location = useLocation();

  const [form] = Form.useForm();
  const [formSelection, setFormSelection] = useState<string>(fields[0]?.data.id);

  const isSimulationsPath = location.pathname.includes("/simulations");

  return (
    <Form form={form} name="simulationFieldSelection">
      <Modal
        cancelText={t("simulationFieldSelectionModal.cancel")}
        onCancel={() => {
          setShowSimulations(false);
          if (isSimulationsPath) navigate(location.pathname.replace("/simulations", "") + location.search);
        }}
        okText={t("simulationFieldSelectionModal.simulate")}
        onOk={() => setSimulationFieldId(formSelection)}
        showModal={showModal}
        title={t("simulationFieldSelectionModal.title")}
        content={
          // @ts-expect-error need to convert to tsx
          <Select
            label={t("simulationFieldSelectionModal.field")}
            name={"selectedFieldId"}
            initialValue={formSelection}
            value={formSelection}
            onChange={(fieldId) => setFormSelection(fieldId)}
          >
            <OptGroup>
              {fields.map((field) => (
                <Option key={field.data.id} value={field.data.id}>
                  {field.data.name}
                </Option>
              ))}
            </OptGroup>
          </Select>
        }
      />
    </Form>
  );
};
